<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Banners</div>
                <div class="text text--thin mb-2">Adicione ou remova banners do dashboard</div>
                <v-btn @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">panorama</v-icon>Novo banner</v-btn>
              </v-col>
              <v-col cols="12" md="5">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <div class="py-2 px-2 table_search_area">
            <v-text-field
              clearable
              hide-details=""
              clear-icon="close"
              v-model="search"
              outlined
              label="Busca"
            ></v-text-field>
          </div>
        </template>
        <template v-slot:item.bar_nome="{ item }">
          {{item.bar_nome}}
          <v-chip v-if="item.bar_ativo" class="ml-2" small color="green">Ativo</v-chip>
          <v-chip v-else class="ml-2" small color="red">Inativo</v-chip>
        </template>
        <template v-slot:item.bar_imagem="{ item }">
          <img class="banner_imagem" :src="item.bar_imagem" alt="Imagem">
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{banner.uuid_bar_id ? 'Editar banner' : 'Novo banner'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formBanners">
          <v-row>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <v-switch
                hide-details
                class="ml-4 mt-0 mb-2"
                color="success"
                v-model="banner.bar_ativo"
                :loading="salvando"
                :disabled="salvando"
                :label="banner.bar_ativo ? 'Ativo' : 'Inativo'"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9" class="pb-0">
              <VueCtkDateTimePicker
                position="bottom"
                v-on:callback="changeDates"
                v-model="data_entrada"
                class="date-picker"
                locale="pt-BR"
                :no-header="true"
                :no-value-to-custom-elem="true"
                :overlay="true"
                :range="true"
                :formatted="'L'"
                :format="'YYYY-MM-DD'"
                color="#004A93"
                :dark="$vuetify.theme.dark"
                :custom-shortcuts="labels"
                button-color="#EC6521"
                :no-button="true"
                :noClearButton="true"
                :auto-close="true"
                :loading="salvando"
                :disabled="salvando"
                :submit="retornoData()"
              >
                <v-btn class="px-2 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                  <b :class="'text ' + ($vuetify.theme.dark ? '' : 'text-primary')">
                    Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                  </b>
                </v-btn>
              </VueCtkDateTimePicker>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="banner.bar_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="banner.bar_link"
                label="Link"
                autofocus
                outlined
                type="link"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="banner.bar_imagem"
                prepend-icon="image"
                label="Adicionar banner*"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                :rules="[rules.required, rules.size]"
                v-if="isObject(banner.bar_imagem)"
                outlined
                hint="Tamanho recomendado: 1920x300px"
                persistent-hint
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="banner.bar_imagem && !isObject(banner.bar_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="banner.bar_imagem">
                  <img alt="Logotipo" :src="banner.bar_imagem" class="banner">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover banner</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditBanner()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Logotipo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover o banner?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Banner
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Banner <b class="text-primary">{{banner ? banner.bar_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeUser()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      search: '',
      modulos: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'bar_id'
        },
        { text: 'Nome', value: 'bar_nome' },
        { text: 'Imagem', value: 'bar_imagem' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      banner: {
        bar_ativo: true,
        bar_nome: '',
        bar_imagem: '',
        bar_de: null,
        bar_ate: null
      },
      de: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).add(1, 'month').format('YYYY-MM-DD'),
      data_entrada: {
        start: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).add(1, 'month').format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' }
      ]
    }
  },
  methods: {
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    changeDates (dates) {
      console.log(dates)
      this.de = dates.start
      this.ate = dates.end
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
        }
      }
    },
    loadFunctions () {
      this.getBanners()
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getBanners () {
      this.loading = true
      await Api.get('banners?intervalo=true')
        .then(res => {
          let info = []
          if (res.data && res.data.length > 0) {
            res.data.map(item => {
              info.push({
                bar_id: item.bar_id,
                bar_ativo: item.bar_ativo,
                bar_link: item.bar_link,
                bar_nome: item.bar_nome,
                bar_imagem: item.bar_imagem,
                bar_de: item.bar_de,
                bar_ate: item.bar_ate,
                uuid_bar_id: item.uuid_bar_id
              })
            })
          }
          this.dados = info
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os banners!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagem () {
      this.banner.bar_imagem = ''
      this.banner.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditBanner () {
      if (!this.$refs.formBanners.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'banners/novo'
      let editado = false
      if (this.banner.uuid_bar_id) {
        endpoint = 'banners/edita'
        editado = true
      }
      this.banner.bar_de = this.data_entrada.start
      this.banner.bar_ate = this.data_entrada.end

      const formData = new FormData()
      Object.keys(this.banner).map((key) => {
        if (key === 'bar_imagem') {
          if (this.$refs.file) {
            formData.append(`bar_imagem`, this.banner.bar_imagem)
          }
        } else if (key === 'bar_ativo') {
          formData.append(`bar_ativo`, this.banner.bar_ativo ? 1 : 0)
        } else {
          if (this.banner[key] != null) {
            formData.append(key, this.banner[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Banner atualizado com sucesso!' : 'Banner cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getBanners()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeUser () {
      this.salvando = true
      Api.delete(`banners/remove/${this.banner.uuid_bar_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getBanners()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover banner!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.banner = JSON.parse(JSON.stringify(item))
      this.data_entrada.start = this.banner.bar_de
      this.data_entrada.end = this.banner.bar_ate
      this.de = this.banner.bar_de
      this.ate = this.banner.bar_ate
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.banner = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelUsuarioDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.banner = {
        bar_ativo: true,
        bar_nome: '',
        bar_imagem: '',
        bar_de: null,
        bar_ate: null
      }
      this.de = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD')
      this.ate = moment(new Date()).add(1, 'month').format('YYYY-MM-DD')
      this.data_entrada = {
        start: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).add(1, 'month').format('YYYY-MM-DD')
      }
      if (this.$refs.formBanners) {
        this.$refs.formBanners.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.banner {
  max-height: 350px;
  max-width: 100%;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.banner_imagem {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Banners.vue